import React from 'react';
import { Card, Table, Progress } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccBottlenecks } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const WorkstationBottleneckAnalyzer: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccBottlenecks(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];
  const maxScore = Math.max(...rows.map((r) => Number(r.severity_score) || 0), 1);

  return (
    <Card id="bottlenecks" title="Bottleneck analyzer (top 10)" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey="work_center"
        dataSource={rows}
        columns={[
          { title: 'Work center', dataIndex: 'work_center' },
          { title: 'Root cause', dataIndex: 'root_cause' },
          { title: 'Action', dataIndex: 'suggested_action', ellipsis: true },
          { title: 'Queue', dataIndex: 'pending_qty', width: 70 },
          { title: 'Insp wait', dataIndex: 'inspection_queue', width: 80 },
          {
            title: 'Severity',
            dataIndex: 'severity_score',
            render: (s: number) => (
              <Progress percent={Math.round((s / maxScore) * 100)} size="small" showInfo={false} />
            ),
          },
        ]}
        pagination={false}
      />
    </Card>
  );
};

export default WorkstationBottleneckAnalyzer;
